// src/redux/thunks/jewelleryPlan/quoteThunks.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import quoteService from "../../../services/jewelleryPlan/quoteService";

/**
 * Check balance and purchasing power
 */
export const checkBalanceThunk = createAsyncThunk(
  "quotes/checkBalance",
  async ({ planId, karat = 22 }, { rejectWithValue }) => {
    try {
      const response = await quoteService.checkBalance(planId, karat);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.message ||
          "Failed to check balance"
      );
    }
  }
);

/**
 * Create balance quote (locks value)
 */
export const createBalanceQuoteThunk = createAsyncThunk(
  "quotes/createBalanceQuote",
  async (quoteData, { rejectWithValue }) => {
    try {
      const response = await quoteService.createBalanceQuote(quoteData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.message || "Failed to create quote"
      );
    }
  }
);

/**
 * Get quote by ID
 */
export const getQuoteThunk = createAsyncThunk(
  "quotes/getQuote",
  async (quoteId, { rejectWithValue }) => {
    try {
      const response = await quoteService.getQuote(quoteId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.message || "Failed to get quote"
      );
    }
  }
);

/**
 * Validate quote
 */
export const validateQuoteThunk = createAsyncThunk(
  "quotes/validateQuote",
  async (quoteId, { rejectWithValue }) => {
    try {
      const response = await quoteService.validateQuote(quoteId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.message ||
          "Failed to validate quote"
      );
    }
  }
);

/**
 * Get all quotes for a plan
 */
export const getPlanQuotesThunk = createAsyncThunk(
  "quotes/getPlanQuotes",
  async ({ planId, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await quoteService.getPlanQuotes(planId, filters);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.message ||
          "Failed to get plan quotes"
      );
    }
  }
);
